<template>
  <div class="content">
    <template>
      <div id="objectHeaderContentHidden" style="display: none;">
        <div><md-icon class="icon-color">dashboard</md-icon></div>
        <div>
          <h1 class="md-title icon-color">{{ $route.name }}</h1>
        </div>
      </div>
      <!-- If current user have lead role in any team then show tabbed interface -->
      <template v-if="isLeadRole">
        <div class="mdTabs">
          <md-tabs class="customTaskDialogTabs tabBar z-index-1" @md-changed="onTabChanged">

            <md-tab id="tab-me" md-label="Me" :class="{ _isActive: 'tab-me' == activeTabId }">
              <!--<PerformanceSnapshot :taskList="allTaskAndTemplateList"></PerformanceSnapshot>-->

              <Tasks :userId="userId" ></Tasks>
              <ElasticList
                  class="_dashboard__alerts"
                  :list="alertsList"
                  :filter="alertsRawFilter"
                  ref="alertsElasticListRef"
                  v-if="userId"
              />
            </md-tab>

            <!-- Teams tab -->
            <md-tab v-if="false" id="tab-teams" md-label="Teams" :class="{ _isActive: 'tab-teams' == activeTabId }">
              <div class="md-layout-item">
                <div class="dynamicList-loading shift-right" v-show="!teamTasksData.length">
                  <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
                </div>
              	<FilterComponent @filter="onTeamTasksDataFilterChange" :items="teamTasksData" />

                <DynamoList 
                  v-for="(_list, _key) in teamTasksData"
                  :key="_key"
                  :list.sync="_list"
                  :assigneeFilters="assigneeFilters"
                ></DynamoList>
              </div>
            </md-tab>
          </md-tabs>
        </div>
      </template>
      <!-- v-else to show only Me tab's content without tabs -->
      <template v-else>
        <!--<PerformanceSnapshot :taskList="allTaskAndTemplateList"></PerformanceSnapshot>-->
        <Tasks :userId="userId" ></Tasks>
        <ElasticList
            class="_dashboard__alerts"
            :list="alertsList"
            :filter="alertsRawFilter"
            ref="alertsElasticListRef"
            v-if="userId"
        />
      </template>
    </template>
  </div>
</template>

<script>
import CustomDashboardList from "@/components/DynamicForm/CustomDashboardList";
import PerformanceSnapshot  from "@/components/DynamicForm/PerformanceSnapshot";
import DynamoList from "@/components/DynamicForm/DynamoList";
import FilterComponent from "@/components/DynamicForm/FilterComponent";
import moment from "moment";
import Amplify, { API, graphqlOperation } from 'aws-amplify';
import * as queries_custom from '@/graphql/queries_custom';
import * as queries from '@/graphql/queries';
import * as mutations from '@/graphql/mutations';
import * as subscriptions from '@/graphql/subscriptions';
import ElasticList from "@/components/DynamicForm/ElasticList";
import _ from 'lodash';

import Tasks from "@/pages/Tasks/Tasks.vue";

import Page from '@/mixins/Page';

export default {
  components: {
    CustomDashboardList,
    PerformanceSnapshot,
    DynamoList,
    ElasticList,
    FilterComponent,
    Tasks
  },
  mixins: [Page],
  computed: {
    userId() {
      return this.$reduce(this, '$Session.userId');
    },
    myTasksFilter: function() {
      const sessUserId = this.$Session.userId;

      let items = ["Closed", "Completed", "Closed_By_Workflow"];
      let filters = [];
      items.forEach(item => {
        let matchObj = {};
        matchObj["status"] = item;
        filters.push({"match_phrase": matchObj });
      });

      if(filters.length){
        filters.push({ match: { isTemplate: true }});
        return { filter: {esQuery: JSON.stringify
          ({"bool":
            {
              "must_not": filters,
              "must":[{"bool":{"should":[{"match_phrase":{"taskUserId":sessUserId}}]}}]          
            }
          })
        }}   
      }   
    },   

    teamTaskFilter: function() {
      let mustNotFilter = [
        { match: { isTemplate: true } }
      ];
      return { must_not: mustNotFilter };
    },
    isLastPage() {
      return this.totalNumberOfRecords <= this.myTasksList.defaults.page * this.myTasksList.defaults.perPage;
    },
    alertsRawFilter: function() { return {"match": {"alertUserId": this.userId }} }
  },
  methods: {
    async getTaskList() {
      let d = new Date();
      let formDate = new Date(d.setDate(d.getDate()-90));
      let params = {
          limit:999,
          sort: {"direction":"desc","field":"createdAt"}   
      };

      params.filter = {
            esQuery: JSON.stringify({
              "bool":{
                "must_not":[{"match":{"isTemplate":true}}],
                "must":[{"bool":{"should":[{"match_phrase":{"taskUserId":this.$Session.userId}}]}},
                        {"bool":{"should":[{"range":{"createdAt":{"time_zone":"+00:00","gte":formDate,"lte":"now"}}}]}}]
              }
            })
      }

      let response = null;
      let error = null;
      let haveData = true;
      let page = 0;
      while (haveData) {
        error = null;
        response = await API.graphql(graphqlOperation(queries_custom["searchDashboardTasks"], params))
        .catch(err => {
            error = err
            if(err.data.searchTasks){
              this.incrementalTaskAndTemplateList = this.incrementalTaskAndTemplateList.concat(err.data.searchTasks.items);
            }
            haveData = err.data.searchTasks && err.data.searchTasks.items.length === params.limit ? true : false;
            if(haveData){
              page++
              params.nextToken = params.limit * page
            }
        });
        if (!error) {
          if(response.data.searchTasks){
            this.incrementalTaskAndTemplateList = this.incrementalTaskAndTemplateList.concat(response.data.searchTasks.items);
          }
          haveData = response.data.searchTasks && response.data.searchTasks.items.length === params.limit ? true : false;
          if(haveData){
            page++
            params.nextToken = params.limit * page
          }
        }
      }
      this.allTaskAndTemplateList = this.incrementalTaskAndTemplateList
    },

    async dataForTeamsTab() {
      const teamIds = [];
      const caseIds = [];
      let response = null;
      let error = null;
      let haveData = true;
      let page = 0;
      this.$Session.groups.forEach((_item, _itemIndex) => {
        if (_item.role == "Lead"){
          teamIds.push({ match: { caseTeamId: _item.teamId } });
        }
      });

      const params = {
        limit: 999,
        filter: {
          esQuery: JSON.stringify({
            bool: {
              must: [
                { bool: { should: teamIds } }
              ]
            }
          })
        }
      };

      if(teamIds.length){
        while (haveData) {
          error = null;
          response = await API.graphql(graphqlOperation(queries_custom["searchCaseCustoms"], params))
          .catch(err => {
              error = err
              if(err.data.searchCases){
                this.casesList = this.casesList.concat(err.data.searchCases.items);
              }
              haveData = err.data.searchCases && err.data.searchCases.items.length === params.limit ? true : false;
              if(haveData){
                page++
                params.nextToken = params.limit * page
              }
          });
          if (!error) {
            if(response.data.searchCases){
              this.casesList = this.casesList.concat(response.data.searchCases.items);
            }
            haveData = response.data.searchCases && response.data.searchCases.items.length === params.limit ? true : false;
            if(haveData){
              page++
              params.nextToken = params.limit * page
            }
          }
        }
        this.allCasesList = this.casesList

        if(this.allCasesList.length){
          const caseIds = [];
          let taskres = null;
          let taskerr= null;
          let moreData = true;
          let taskPage = 0;
          this.allCasesList.forEach((_item, _itemIndex) => {
              caseIds.push({ match: { taskCaseId: _item.id } });
          });

          const taskParams = {
            limit: 999,
            filter: {
              esQuery: JSON.stringify({
                bool: {
                  must_not:[{match:{isTemplate:true}},{match:{status:'Completed'}},{match:{status:'Closed_By_Workflow'}}],
                  must: [
                    { bool: { should: caseIds } }
                  ]
                }
              })
            }
          };

          if(caseIds.length){
            while (moreData) {
              taskerr = null;
              taskres = await API.graphql(graphqlOperation(queries_custom["searchDashboardTasks"], taskParams))
              .catch(err => {
                  taskerr = err
                  if(err.data.searchTasks){
                    this.getTeamTaskList = this.getTeamTaskList.concat(err.data.searchTasks.items);
                  }
                  moreData = err.data.searchTasks && err.data.searchTasks.items.length === taskParams.limit ? true : false;
                  if(moreData){
                    taskPage++
                    taskParams.nextToken = taskParams.limit * taskPage
                  }
              });
              if (!taskerr) {
                if(taskres.data.searchTasks){
                  this.getTeamTaskList = this.getTeamTaskList.concat(taskres.data.searchTasks.items);
                }
                moreData = taskres.data.searchTasks && taskres.data.searchTasks.items.length === taskParams.limit ? true : false;
                if(moreData){
                  taskPage++
                  taskParams.nextToken = taskParams.limit * taskPage
                }
              }
            }
            this.allTaskList = this.getTeamTaskList

            let result = [];
            let newResult = {};
            if (this.allTaskList.length) {
              this.allTaskList.forEach(item => {
                if (item && item.case && item.case.isCompleteInOrder && !item.isAvailable) {
                  return;
                }
                if (
                  item.case !== null &&

                  (item.dateDue && (moment(item.dateDue) <= moment())) &&

                  item.user !== null
                ) {
                  item.team = item.case.team.name;
                  item.assignee = item.user.given_name + ' ' + item.user.family_name;
                  if(!this.dynamoTeamList.assigneeList.includes(item.assignee)) {
                    this.dynamoTeamList.assigneeList.push(item.assignee);
                  }
                  item.caseId = item.case.id;
                  item.case = item.case.subject;
                  item.dateDueOrig = moment(item.dateDue).toDate().toISOString();
                  item.dateDue = moment(String(item.dateDue)).format('MMM DD, YYYY');
                  result.push(item);
                }
              });

              let childArr = [];
              this.currentUserGroups.forEach(_groupItem => {
                result.map(_item => {
                  if(_item.team == _groupItem) {
                    childArr.push(_item);
                  }
                });
                newResult[_groupItem] = childArr;
                childArr = [];
              });

              //generate team-wise tasks records
              this.teamTasksData = [];
              Object.keys(newResult).map(_key => {
                if(newResult[_key].length > 0) {
                  let options = _.clone(this.dynamoTeamList);
                  //use lodash method to sort with dateDue field
                  const tableData = _.sortBy(newResult[_key], 'dateDueOrig');
                  options.sourceData = tableData;
                  options.tableData = tableData;
                  this.teamTasksData.push(options);
                }
              });
            }
          }
        }
      }
    },

    loadNextCaseTasks(){
      this.$set(this.myTasksList.defaults, 'page', (this.myTasksList.defaults.page + 1));
      /**
       * ATLAS-577 - Dashboard>>My Task List : Clicking on Load more button,additional Task are not showing
       * Watch for changes to loadNextItems in RecordList.js and load new items
       */
      this.$set(this.myTasksList.defaults, 'loadNextItems', this.myTasksList.defaults.page);
    },
    onTeamTasksDataFilterChange(filterdItems) {
      this.assigneeFilters = filterdItems;
    },
    onTabChanged(id) {
      this.activeTabId = id;
    },
    /**
     * Get the current alert items from reference element - this is used
     * in perfoming updates while responding to subscriptions
     * @returns {Mixed} undefined if list not found else array
     */
    getAlertItemsFromRef() {
      const ref = this.$refs.alertsElasticListRef;
      if (!ref || !ref.data || !ref.data.default || !ref.data.default.items) {
        return undefined;
      }
      return ref.data.default.items;
    },
    /**
     * Get index of an alert item in our elastic list
     * @returns {Int}
     */
    getAlertIndexFromRef(eventRecord) {
      const items = this.getAlertItemsFromRef();
      if (!items) {
        return -1;
      }
      return items.findIndex(_alert => _alert.id == eventRecord.id);
    }
  },
  data() {
    return {
      incrementalTaskAndTemplateList: [],
      allTaskAndTemplateList: [],
      allTaskList: [],
      getTeamTaskList: [],
      activeTabId: "tab-me",
      assigneeFilters: [],
      totalNumberOfRecords: 0,
      isLeadRole: false,
      currentUserGroups: [],
      teamTasksData: [],
      casesList: [],
      allCasesList: [],
      myTasksList: {
        hideListHeader: false,
        hideNewRecordButton: true,
        skipCardLayout: false,
        showRefreshIcon: false,
        showTableToolbar: false,
        showActionResults: false,
        showItemActions: true,
        HyperLinkColumns: {
          editColLink: "cases",
          colName: "case",
          fieldId: "caseId",
          click: "handleEdit",
          tabName: "tasks"
        },
        editPath: "tasks",
        pageTitle: "My Tasks",
        pageIcon: "assignment",
        listQueryId: "searchDashboardTasks",
        responseFieldName: "searchTasks",
        itemActions: [
          {
            class: "md-just-icon md-warning md-simple",
            icon: "input",
            click: "handleEdit"
          }
        ],
        columns: {
          case: { label: "Case" },
          subject: { label: "Task" },
          status: { label: "Status" },
          priority: { label: "Priority" },
          dateDue: { label: "Due Date" },
          service: { label: "Service" }
        },
        defaults: {
          sort: "createdAt",
          sortDir: "desc",
          perPage: 10,
          page: 1,
          itemsToLoad: 999
        },
        fuseSearch: null,
        formatResponse: data => {
          let result = [];
          let filterStatus = ["Closed", "Completed", "Closed_By_Workflow"];
          if (data && data.searchTasks && data.searchTasks.items.length) {
            data.searchTasks.items.forEach(item => {
              if (item && item.case && item.case.isCompleteInOrder && !item.isAvailable) {
                return;
              }
              if (
                item.case !== null &&
                (!filterStatus.includes(item.status)) &&
                (item.user && item.user.id === this.$Session.userId) &&
                (item.dateDue && (moment(item.dateDue) <= moment()))
              ) {
                //ATLAS-1182: <Dashboard><Task list> Add service column to the task list
                if (item.case.services && item.case.services.items && item.case.services.items.length) {
                  item.service = item.case.services.items[0] ? item.case.services.items[0].service.name : '';
                }
                item.caseId = item.case.id;
                item.case = item.case.subject;
                item.dateDue = moment(String(item.dateDue)).format('MMM DD, YYYY');
                result.push(item);
              }
            });
          }
          this.totalNumberOfRecords = result.length;

          return result;
        }
      },
      dynamoTeamList: {
        isApiDisabled: true,
        searchForFilteredData: true,
        showRelatedLinkDialog: false,
        needsRefresh: false,
        hideTableToolbar: false,
        searchRecordsInput: false,
        recordsPerPageInput: true,
        hideRefreshIcon: true,
        hideNewRecordButton: true,
        hideListHeader: true,
        hideItemActions: true,
        showTeamTitle: true,
        HyperLinkColumns: {
          editColLink: "cases",
          colName: "case",
          fieldId: "caseId",
          click: "handleEdit",
          tabName: "tasks"
        },
        editPath: "tasks",
        pageTitle: "Team Tasks",
        pageIcon: "assignment",
        listQueryId: "searchDashboardTasks",
        columns: {
          assignee: { label: "Assignee", sortable: true },
          case: { label: "Case", sortable: true },
          subject: { label: "Task", sortable: true },
          status: { label: "Status", sortable: true },
          priority: { label: "Priority", sortable: true },
          dateDueOrig: { label: "Due Date", sortable: true, displayColumn: 'dateDue' }
        },
        linkConfigs: [
          {
            name: 'subject',
            hrefCallback: (column, name, item) => {
              return '#/tasks/' + item.id;
            },
            titleCallback: (column, name, item) => {
              return item.subject;
            },
          }
        ],
        currentSort: "name",
        currentSortOrder: "asc",
        pagination: {
          perPage: 5,
          currentPage: 1,
          total: 0
        },
        tableData: [],
        searchedData: [],
        fuseSearch: null,
        assigneeList: [],
        filteredData: []
      },
      alertsList: {
        columns: {
          subject: { label: "Subject", sortable: true },
          body: { label: "Body", sortable: true },
          // link: { label: "Link", sortable: true },
          createdAt: { label: "Created At", sortable: true, dateFilter: true },
          level: { label: "Level", sortable: true },
          status : { label: "Status", sortable: true },
        },
        addonFilters: [
          {
            id: 'status',
            query: 'listAlertStatusEnum',
            queryOptionsKey: 'enumValues',
            key: 'name',
            label: 'name',
            placeholder: 'Filter Status',
            modal: '',
            value: '',
            optionsFilter: (option) => {
              return -1 == ['unread', 'read'].indexOf(option.name);
            },
            default: {
              key: 'name',
              value: 'Unread',
            }
          },
        ],
        itemActions: [
          {
            class: 'md-just-icon md-warning md-simple',
            classAdded: 'md-just-icon md-warning md-simple',
            icon: 'input',
            iconAdded: 'input',
            click: (item) => {
              window.location = `/${item.link}`;
              const input = { id: item.id, status: 'Read' };
              const request = graphqlOperation(mutations['updateAlert'], { input });
              API.graphql(request).then(response => {
                console.log('Alert marked as Read', response.data);
              });
            },
            showCallback: (item) => {
              return !item.status || 'unread' == item.status.toLowerCase();
            }
          },
          {
            class: 'md-just-icon md-warning md-simple',
            classAdded: 'md-just-icon md-warning md-simple',
            icon: 'close',
            iconAdded: 'close',
            click: (item, allItems) => {
              // const index = allItems.findIndex(_item => _item.id == item.id);
              // if (-1 != index) {
              //   this.$set(allItems[index], 'status', 'Read');
              // }
              const input = { id: item.id, status: 'Read' };
              const request = graphqlOperation(mutations['updateAlert'], { input });
              API.graphql(request).then(response => {
                console.log('Alert marked as Read', response.data);
              });
            },
            showCallback: (item) => {
              return !item.status || 'unread' == item.status.toLowerCase();
            }
          },
        ],
        subscriptions: {
          'onCreateAlert': {
            result: null,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateAlert');
              const eventRecord = eventData.value.data.onCreateAlert;
              const items = this.getAlertItemsFromRef();
              if (eventRecord && eventRecord.id && items) {
                this.$refs.alertsElasticListRef.refresh();
              }
            },
          },
          'onUpdateAlert': {
            result: null,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onUpdateAlert');
              const eventRecord = eventData.value.data.onUpdateAlert;
              const items = this.getAlertItemsFromRef();
              const index = this.getAlertIndexFromRef(eventRecord);
              if (eventRecord && eventRecord.id && -1 != index) {
                this.$set(items, index, eventRecord);
                const addonFilters = this.$refs.alertsElasticListRef.addonFilters;
                let isUnreadOnlyActive = false;
                if (addonFilters && addonFilters.length) {
                  addonFilters.map(_filter => {
                    if ('status' == _filter.id && (
                      'unread' == _filter.value.toLowerCase() ||
                      'unread' == _filter.modal.toLowerCase()
                    )) {
                      isUnreadOnlyActive = true;
                    }
                  });
                }
                if (isUnreadOnlyActive) {
                  items.splice(index, 1);
                }
              }
            }
          },
          'onDeleteAlert': {
            result: null,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeleteAlert');
              const eventRecord = eventData.value.data.onUpdateAlert;
              const items = this.getAlertItemsFromRef();
              const index = this.getAlertIndexFromRef(eventRecord);
              if (eventRecord && eventRecord.id && -1 != index) {
                items.splice(index, 1);
              }
            }
          },
        },
        formatResponse: data => {
          let result = [];
          let items = this.$reduce(data, 'searchAlerts.items');
          if (items && items.length) {
            items.forEach(item => {
                if(item.body){
                    let text = (String(item.body).replace(/<[^>]+>/gm, '')).replace(/\&nbsp;/g, '');
                    item.body = text.substring(0, 20);
                }else{
                    item.body = '';
                }
                result.push(item);
            });
            return result;
          }
          return [];
        },
        perPageOptions: [5, 10, 25, 50],
        defaults: {
          sort: 'createdAt',
          sortDir: 'desc',
          perPage: 10,
        },
        hideTableToolbar: false,
        searchRecordsInput: false,
        recordsPerPageInput: false,
        hideRefreshIcon: true,
        hideNewRecordButton: true,
        hideListHeader: false,
        hideItemActions: false,
        pageTitle: "Notifications",
        pageIcon: "alert",
        listQueryId: "searchAlertsCustom",
        responseFieldName: 'searchAlerts',
        tableData: [],
        searchedData: [],
        fuseSearch: null,
        paginationScrollTop:'._dashboard__alerts'
      }
    };
  },
  watch: {
    '$Session.userId': {
      immediate: true,
      handler: function() {
        this.userId = this.$Session.userId;
        if(this.$Session.userId) {
          this.getTaskList();
        }
      }
    },
    '$Session.groups': {
      deep: true,
      immediate: true,
      handler: function() {
        if (this.$Session.groups) {
          const sessUserGroup = this.$Session.groups;
          sessUserGroup.forEach((_item, _itemIndex) => {
            if (_item.role == "Lead") this.isLeadRole = true;
            this.currentUserGroups.push(_item.name);
          });
          this.dataForTeamsTab();
        }
      }
    }
  }
};
</script>

<style lang="css">
#pageTitle .md-title {
  font-weight: 400 !important;
  font-size: 1.5em !important;
}
h4.teamTitle {
  font-weight: 500;
  font-size: 1.2em;
  margin: 0px 0px 4px;
  color: #3c4858;
}
#tab-teams .md-table-head-label {
  color: grey;
  font-size: 0.9rem;
}
</style>

<style lang="css" scoped>
.md-card .md-card-header.md-card-header-icon .title {
  width: auto;
  display: inline-block;
  float: left;
}

.md-menu.md-select {
  max-width: 200px;
  display: inline-block;
  padding-top: 7px;
  float: left;
  margin-left: 20px;
}

.content .mdTabs {
  border: none;
}

</style>

<style lang="scss">
  ._dashboard__alerts ._addonFilters {
    z-index: 10;
    top: 0;
  }
  .dynamicList-loading.shift-right{
    margin-left:50%;
  }
  .z-index-1 .md-tabs-navigation {
    z-index: 1 !important;
  }
</style>